import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ValueAsFunction from './ValueAsFunction';
import ClientProvider from './client';
export default createDemo(import.meta.url, ValueAsFunction, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/usage/demos/value-as-function/ValueAsFunction.tsx",
    "fileName": "ValueAsFunction.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { Theme } from '@mui/material/styles';\n\nexport default function ValueAsFunction() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          p: 1,\n          border: 1,\n          borderColor: (theme: Theme) => theme.palette.primary.main,\n        }}\n      >\n        Border color with theme value.\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 18,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { Theme } from '@mui/material/styles';\n\nexport default function ValueAsFunction() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box\n        sx={{\n          p: 1,\n          border: 1,\n          borderColor: (theme: Theme) => theme.palette.primary.main,\n        }}\n      >\n        Border color with theme value.\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "          ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "          ",
              [
                "span",
                "pl-en",
                "borderColor"
              ],
              ": (",
              [
                "span",
                "pl-v di-jv",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-en",
                "Theme"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "palette"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "primary"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "main"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            "        Border color with theme value."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 18,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
